import { Viewport, useMatchMedia } from "@repo/ui/viewport";
import viewports from "@/theme/viewports";

export const Small = ({ children }: { children: React.ReactNode }) => (
  <Viewport is={viewports.small}>{children}</Viewport>
);
export const Large = ({ children }: { children: React.ReactNode }) => (
  <Viewport is={viewports.large}>{children}</Viewport>
);

export const useSmallViewport = () => !!useMatchMedia(viewports.small);
export const useLargeViewport = () => !!useMatchMedia(viewports.large);
